module.exports = __webpack_public_path__ + "static/media/word.4b13f967.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/word.jpg
// module id = 33
// module chunks = 0